import * as React from 'react';
import {
  INavLinkGroup,
  INavLink,
  Nav,
  IRenderFunction,
} from '@fluentui/react';
import { useEffect, useState } from 'react';
import { GetTreeByWorkspaceFolderIdAll } from '../../../../services/Item/ItemServicesGet';
import { WorkSpaceItemRecursive } from '../../../../model/ItemModel';
import { folderIcon } from '../../../../assets/icons';
import LoaderComp from '../../../../components/Loader/LoaderComp';
import { useTranslation } from 'react-i18next';
import { ConfirmIcon } from '../../../../assets/icons/icons.tsx/ConfirmIcon';
import { FolderNotFound } from '../../../../assets/icons/folderNotFound';
import { FatherfolderProps } from '../../../RecicleBin/GridArchive/GridRestore/RestoreConfirm';

interface FolderPathProps {
  idWorkspace: string;
  fatherFolder?: string;
  newFatherFolder: (fatherFolder: FatherfolderProps) => void;
  isDisabled?: boolean;
  listItensTypeFolder?: string[];
}

export const FolderPath: React.FunctionComponent<FolderPathProps> = ({
  idWorkspace,
  fatherFolder,
  newFatherFolder,
  isDisabled,
  listItensTypeFolder
}) => {

  const [reload, setReload] = useState<boolean>(false);
  const [fatherId, setFatherId] = useState<string | undefined>(undefined);
  const [displayNav, setDisplayNav] = useState<boolean>(false);

  const [nav, setNav] = useState<INavLinkGroup[]>([]);

  const { t, i18n } = useTranslation();

  const renderMenuList: IRenderFunction<INavLink> = (
    menuListProps: INavLink | undefined,

    defaultRender: IRenderFunction<INavLink> | undefined,
  ) => {
    if (menuListProps != undefined && defaultRender != undefined) {
      return (
        <div
          style={{ display: "flex", width: "100%", height: "38px", paddingLeft: "5px", paddingRight: "5px", }}
        >
          <img width={20} src={folderIcon} draggable={false} style={{ marginRight: '20px' }} />

          <div
            style={{
              color: "black",

              fontWeight: 600,
            }}
          >
            {menuListProps.name}
          </div>
          {fatherId === menuListProps.key &&
            <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "end", width: "100%" }}>
              <ConfirmIcon color='#22638D' />
            </div>
          }
        </div>
      );
    } else {
      return null;
    }
  };

  useEffect(() => {
    setFatherId(fatherFolder);
    const arrayNav: INavLinkGroup[] = [];
    const newNav: INavLinkGroup = {
      links: [],
    };

    setReload(true);

    GetTreeByWorkspaceFolderIdAll(idWorkspace)
      .then((WorkSpaceItem) => {
        WorkSpaceItem.forEach((element) => {
          const link = creatLink(element);
          if (link) {
            newNav.links.push(link);
          }
        });

        setDisplayNav(true);
        arrayNav.push(newNav);
        setNav(arrayNav);
      })
      .catch(() => { })
      .finally(() => setReload(false));

  }, [idWorkspace]);

  function creatLink(element: WorkSpaceItemRecursive): INavLink | null {
    if (!element.id || !element.name || listItensTypeFolder?.includes(element.id)) {
      return null;
    }

    const link: INavLink = {
      key: element.id,
      name: element.name!,
      url: "",
      onClick: (ev?: React.MouseEvent<HTMLElement>, item?: INavLink) => {
        if (isDisabled) {
          ev?.preventDefault();
          ev?.stopPropagation();
          return;
        }

        ev?.stopPropagation();
        setFatherId((prevFatherId) => {
          if (element.id === prevFatherId) {
            newFatherFolder({ id: undefined, name: undefined });
            return undefined;
          } else {
            if (element.id) {
              newFatherFolder({ id: element.id, name: element.name! });
            }
            return element.id;
          }
        });
      },
      links: [],
    };

    if (element.children != undefined) {
      element.children.forEach((child) => {
        const childLink = creatLink(child);
        if (childLink) {
          link.links?.push(childLink);
        }
      });
    }

    return link;
  }

  return (
    <div style={{ marginTop: "10px" }}>
      <div style={{ color: "#2D2D2D", fontWeight: "normal", lineHeight:"16px", fontSize: "12px", marginBottom: "8px" }}>
        {t("RecicleBin.folder")}
      </div>
      <div style={{ border: "1px solid rgb(45, 45, 45, 0.2)", width: "100%", height: "140px", borderRadius: "4px", overflowY: 'auto', scrollbarWidth: "thin" }}>
        {reload ? (
          <LoaderComp big={true} />) :
          (<div style={{ height: "100%" }}>
            {displayNav ? (
              <Nav
                groups={nav}
                onRenderLink={renderMenuList}
                styles={{
                  linkText: {
                    color: "black",
                    selectors: { "&:hover": { color: isDisabled ? "black" : "inherit" } },
                  },
                  link: {
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.5 : 1,
                    selectors: {
                      "&:hover": {
                        backgroundColor: isDisabled ? "transparent" : "inherit",
                      },
                    },
                  },
                  chevronButton: {
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.5 : 1,
                  },
                  "groupContent":{
                    animationName: "none"
                  }
                }}
              />
            ) :
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                flexWrap: "wrap",
                height: "100%",
                width: "100%",
                background: "#f4f7f9"
              }}>
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  height: "100%"
                }}>
                  <FolderNotFound />
                  <div style={{ font: "normal normal 600 14px/21px Segoe UI", color: "#2D2D2D" }}>{t("RecicleBin.emptyRecycleBinPartD")}</div>
                  <div style={{ font: "normal normal normal 12px/18px Segoe UI", color: "#2D2D2D", opacity: ".6" }}>{t("RecicleBin.selectOneWorkspace")}</div>
                </div>
              </div>
            }
          </div>)}
      </div>
    </div>
  );
};
